import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

/**
 * Custom hook to fetch submittals with a due date in the next 7 days and no submittal date.
 * Returns { dueSoonSubmittals, loading, error }
 */
export default function useSubmittalsDueSoon() {
  const [dueSoonSubmittals, setDueSoonSubmittals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSubmittals = async () => {
      setLoading(true);
      setError(null);

      const today = new Date();
      const nextWeek = new Date();
      nextWeek.setDate(today.getDate() + 7);

      // Format dates as YYYY-MM-DD
      const todayStr = today.toISOString().split('T')[0];
      const nextWeekStr = nextWeek.toISOString().split('T')[0];

      const { data, error } = await supabase
        .from('submittal_schedule')
        .select('*')
        .gt('deadline', todayStr)
        .lte('deadline', nextWeekStr)
        .is('submittal_date', null);

      if (error) {
        setError(error);
      } else {
        setDueSoonSubmittals(data);
      }

      setLoading(false);
    };

    fetchSubmittals();
  }, []);

  return { dueSoonSubmittals, loading, error };
}